import { useEffect, useState } from "react"
import { GiftIcon, ClipboardDocumentIcon, CheckIcon, ShareIcon, ExclamationTriangleIcon } from "@heroicons/react/24/outline"
import { getReferralLinkApi } from "../../features/referrals/api/referrals.api"
import { Section } from "./ui"

const REFERRAL_BASE_URL = "https://vkonekte.com/r"

export const InviteFriendBlock = () => {
  const [code, setCode] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [copied, setCopied] = useState(false)

  const load = () => {
    setLoading(true)
    setError(false)
    getReferralLinkApi()
      .then((res) => setCode(res.data.referral_code))
      .catch(() => setError(true))
      .finally(() => setLoading(false))
  }

  useEffect(() => { load() }, [])

  const link = code ? `${REFERRAL_BASE_URL}/${code}` : ""

  const handleCopy = async () => {
    if (!link) return
    await navigator.clipboard.writeText(link)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  const handleShare = async () => {
    if (!link) return
    if (navigator.share) {
      try {
        await navigator.share({ title: "Vkonekte", url: link })
      } catch {
        // пользователь закрыл диалог — ничего не делаем
      }
    } else {
      handleCopy()
    }
  }

  return (
    <Section id="invite" title="Invite a friend" icon={GiftIcon} iconColor="text-pink-500 bg-pink-50">
      <p className="text-sm text-gray-500 leading-relaxed">
        Поделитесь своей персональной ссылкой — друг перейдёт по ней и
        зарегистрируется в Vkonekte.
      </p>

      {loading ? (
        <div className="h-10 bg-gray-100 rounded-lg animate-pulse" />
      ) : error ? (
        <div className="flex items-center justify-between gap-3 bg-red-50 border border-red-100 rounded-lg px-3 py-2.5">
          <span className="flex items-center gap-2 text-sm text-red-600">
            <ExclamationTriangleIcon className="w-4 h-4 flex-shrink-0" />
            Не удалось получить ссылку
          </span>
          <button onClick={load} className="text-xs font-medium text-red-600 hover:text-red-700 underline flex-shrink-0">
            Повторить
          </button>
        </div>
      ) : (
        <div className="flex items-center gap-2">
          <input
            readOnly
            value={link}
            onFocus={(e) => e.target.select()}
            className="flex-1 min-w-0 border border-gray-200 rounded-lg px-3 py-2 text-sm text-gray-600 bg-gray-50 focus:outline-none"
          />
          <button
            onClick={handleCopy}
            title="Скопировать ссылку"
            className="flex items-center gap-1.5 px-3 py-2 rounded-lg border border-gray-200 text-sm text-gray-600 hover:bg-gray-50 hover:text-gray-900 transition flex-shrink-0"
          >
            {copied ? <CheckIcon className="w-4 h-4 text-emerald-500" /> : <ClipboardDocumentIcon className="w-4 h-4" />}
            {copied ? "Скопировано" : "Копировать"}
          </button>
          <button
            onClick={handleShare}
            title="Поделиться"
            className="flex items-center justify-center w-9 h-9 rounded-lg bg-blue-600 hover:bg-blue-700 text-white transition flex-shrink-0"
          >
            <ShareIcon className="w-4 h-4" />
          </button>
        </div>
      )}
    </Section>
  )
}